/** Zona de visualización de fichadas (misma que ATTENDANCE_SHIFT_TZ en backend). */
export const ATTENDANCE_DISPLAY_TZ = 'America/Argentina/Buenos_Aires';

/**
 * Instantes de la API: TIMESTAMPTZ en UTC. Si vienen sin offset (naive), se interpretan como UTC.
 */
export function parseApiDateTime(iso) {
  if (!iso) return null;
  const s = String(iso).trim();
  if (/[zZ]$/.test(s) || /[+-]\d{2}:\d{2}$/.test(s)) {
    return new Date(s);
  }
  return new Date(`${s}Z`);
}

export function formatAttendanceHm(iso) {
  const d = parseApiDateTime(iso);
  if (!d || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('es-AR', {
    timeZone: ATTENDANCE_DISPLAY_TZ,
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Salida que cerró la jornada al día siguiente (ej. olvidó fichar y salió al abrir la app). */
export function formatCheckOutWithNextDay(iso, checkOutNextDay) {
  const hm = formatAttendanceHm(iso);
  if (hm === '—' || !checkOutNextDay) return hm;
  return `${hm} (+1 día)`;
}

export function parseApiDateTimeMs(iso) {
  const d = parseApiDateTime(iso);
  return d && !Number.isNaN(d.getTime()) ? d.getTime() : null;
}

/** Límite HH:MM del turno en ms (misma zona que ATTENDANCE_SHIFT_TZ; AR = UTC−3 sin DST). */
export function shiftBoundaryMs(boardDateYmd, hhmm) {
  const m = String(hhmm || '')
    .trim()
    .match(/^(\d{1,2}):(\d{2})$/);
  if (!m || !boardDateYmd) return null;
  const h = String(m[1]).padStart(2, '0');
  const min = m[2];
  if (ATTENDANCE_DISPLAY_TZ === 'America/Argentina/Buenos_Aires') {
    return new Date(`${boardDateYmd}T${h}:${min}:00-03:00`).getTime();
  }
  const [Y, Mo, D] = boardDateYmd.split('-').map(Number);
  return new Date(Y, Mo - 1, D, Number(m[1]), Number(min), 0, 0).getTime();
}
